import { Grid, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { triggerEmailOtp } from "../../../../../../../../features/post";
import { isEmpty } from "lodash";
import AppModal from "../../../../../../modals/app-modal";

const EmailInputModal = ({
  account = {},
  visibility,
  handleClose,
  setDisplayOtpInputModal,
  setDisplayEmailInputModal,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const triggerOtp = async () => {
    try {
      setLoading(true);
      const data = { email, memberId: account.memberId };
      const response = await triggerEmailOtp({ data });
      if (!response.success) {
        switch (response.body.code) {
          case 1201:
            setError("Too many attempts, Try again later");
            break;
          case 1108:
            setError("Email already in use");
            break;
          default:
            setError("Unknown error occurred");
            break;
        }
        return;
      }
      sessionStorage.setItem("emailUpdateToken", response.body.id);
      sessionStorage.setItem("pendingEmailAddress", response.body.sendTo);
      sessionStorage.setItem("emailUpdateRetryTime", response.body.retryIn);
      setDisplayEmailInputModal(false);
      setDisplayOtpInputModal(true);
    } catch (error) {
      console.log("Error >>>>", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const pendingEmail = sessionStorage.getItem("pendingEmailAddress");
    setEmail(pendingEmail ?? account.email ?? "");
  }, [account]);

  return (
    <AppModal
      visibility={visibility}
      handleClose={handleClose}
      title="Update Email"
      onSecondaryAction={handleClose}
      onPrimaryAction={() => triggerOtp()}
      disablePrimaryAction={
        loading || isEmpty(account) || isEmpty(email) || account.email === email
      }
      loading={loading}
    >
      <Grid container direction="column" className="gap-y-8 pb-16">
        <Typography variant="body2">Email</Typography>
        <TextField
          size="small"
          variant="outlined"
          disabled={isEmpty(account)}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
        />
        {error && (
          <Typography variant="caption" style={{ color: "red" }}>
            {error}
          </Typography>
        )}
      </Grid>
    </AppModal>
  );
};

export default EmailInputModal;
